import { LogIn } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { defaultServer, needsServerAddress, normalizeServer, setServer } from '../lib/native';
import { session } from '../lib/session';
import { useStore } from '../store';
import { Field } from './ui';

export function Login() {
  const connError = useStore((s) => s.connError);
  const serverName = useStore((s) => s.serverName);
  const [server, setServerInput] = useState(defaultServer());
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      // Start the audio context inside the click gesture — iOS/Safari require it.
      void session.audio.ensure();
      if (needsServerAddress()) {
        if (!normalizeServer(server)) throw new Error('Enter the server address');
        setServer(server);
      }
      await session.login(username.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <img className="login__logo" src="/brand/09-stacked-dark.svg" alt="BCComms — Broadcast Communications System" />
        <div className="eyebrow login__eyebrow">Intercom · IFB · {serverName}</div>
        {needsServerAddress() && (
          <Field label="Server" help="e.g. 192.168.1.20:4000 or https://comms.example.com">
            <input className="input" inputMode="url" autoCapitalize="none" autoCorrect="off" placeholder="host:port" value={server} onChange={(e) => setServerInput(e.target.value)} />
          </Field>
        )}
        <Field label="Username">
          <input className="input" autoFocus={!needsServerAddress()} autoCapitalize="none" autoCorrect="off" value={username} onChange={(e) => setUsername(e.target.value)} />
        </Field>
        <Field label="Password">
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        {(error ?? connError) && <p className="error">{error ?? connError}</p>}
        <button className="btn btn--primary btn--lg btn--block" disabled={busy || !username || !password || (needsServerAddress() && !server)}>
          <LogIn size={18} /> {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
